export default "/images/vendor/flag-icons/flags/1x1/ss.svg?252b833eee63afee120bcd1e74639f9e";